export const auxiliaryQuestions = [
  {
    questionNumber: 1,
    questionText: "Could you send me some stationery?",
    choices: {
      A: "The station is a block away.",
      B: "Sure, I'll send it this afternoon.",
      C: "They keep stationary bikes at the gym.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "문구류를 좀 보내주실 수 있나요?",
      choices: {
        A: "역은 한 블록 떨어져 있습니다.",
        B: "네, 오후에 보내드리겠습니다.",
        C: "그들은 체육관에 고정식 자전거를 보관합니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 요청에 응하겠다는 응답입니다. A와 C는 'stationery(문구류)'와 발음이 비슷한 'station(역)'과 'stationary(고정된)'를 혼동한 틀린 답변입니다.",
  },
  {
    questionNumber: 2,
    questionText: "Could you pour me another cup of coffee?",
    choices: {
      A: "The company's profits are poor this quarter.",
      B: "The coffee pot is on the stove.",
      C: "Certainly, I'll pour one right away.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "커피 한 잔 더 따라주실 수 있나요?",
      choices: {
        A: "회사의 이번 분기 수익은 저조합니다.",
        B: "커피포트는 스토브 위에 있습니다.",
        C: "물론이죠, 지금 바로 따라드리겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 커피를 따라주겠다는 응답입니다. A는 'pour(따르다)'와 발음이 비슷한 'poor(저조한)'를 혼동한 틀린 답변이고, B는 요청에 응하는 대신 단순히 커피포트의 위치를 알려주는 부적절한 응답입니다.",
  },
  {
    questionNumber: 3,
    questionText: "Could you mail me the contract by tomorrow?",
    choices: {
      A: "The male employees responded promptly.",
      B: "The mailroom is next to HR.",
      C: "I'll mail it before five.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "내일까지 계약서를 우편으로 보내주실 수 있나요?",
      choices: {
        A: "남자 직원들이 신속하게 응답했습니다.",
        B: "우편실은 인사과 옆에 있습니다.",
        C: "5시 전에 보내드리겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 계약서를 보내주겠다는 응답입니다. A는 'mail(우편)'과 발음이 비슷한 'male(남성)'을 혼동한 틀린 답변이고, B는 요청에 응하는 대신 단순히 우편실의 위치를 알려주는 부적절한 응답입니다.",
  },
  {
    questionNumber: 4,
    questionText: "Could you reserve a suite for our client?",
    choices: {
      A: "Sure, I'll book it today.",
      B: "The smell of sweet pastries fills the lobby.",
      C: "The room service menu has several options.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "고객을 위해 스위트룸을 예약해 주실 수 있나요?",
      choices: {
        A: "물론이죠, 오늘 예약해 드리겠습니다.",
        B: "달콤한 페이스트리 향이 로비에 가득합니다.",
        C: "룸서비스 메뉴에는 여러 옵션이 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 스위트룸을 예약해 주겠다는 응답입니다. B는 'suite(스위트룸)'와 발음이 비슷한 'sweet(달콤한)'을 혼동한 틀린 답변이고, C는 요청에 응하는 대신 단순히 룸서비스 메뉴에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 5,
    questionText: "Could you forward the email to the sales team?",
    choices: {
      A: "Certainly, I'll send it now.",
      B: "I read the foreword before the introduction.",
      C: "It's in the sales report section.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "영업팀에 이메일을 전달해 주실 수 있나요?",
      choices: {
        A: "물론이죠, 지금 보내드리겠습니다.",
        B: "서문을 서론 전에 읽었습니다.",
        C: "영업 보고서 섹션에 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 이메일을 전달해 주겠다는 응답입니다. B는 'forward(전달하다)'와 발음이 비슷한 'foreword(서문)'을 혼동한 틀린 답변이고, C는 요청에 응하는 대신 단순히 영업 보고서의 위치를 알려주는 부적절한 응답입니다.",
  },
  {
    questionNumber: 6,
    questionText: "Could you advise on the best route to the venue?",
    choices: {
      A: "That advice was very helpful.",
      B: "I recommend taking Main Street.",
      C: "The venue opens at eight.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "행사장까지 가는 최선의 경로를 알려주실 수 있나요?",
      choices: {
        A: "그 조언은 매우 유용했습니다.",
        B: "메인 스트리트로 가는 것을 추천합니다.",
        C: "행사장은 8시에 개장합니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 행사장까지 가는 최선의 경로를 추천해주는 응답입니다. A는 과거형으로 현재의 요청에 대한 적절한 응답이 아니며, C는 요청에 응하는 대신 단순히 행사장의 개장 시간을 알려주는 부적절한 응답입니다.",
  },
  {
    questionNumber: 7,
    questionText: "Could you renew my parking permit?",
    choices: {
      A: "The new policy starts next month.",
      B: "Sure, I'll submit the form.",
      C: "Your car is in the parking lot.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "주차 허가증을 갱신해 주실 수 있나요?",
      choices: {
        A: "새 정책은 다음 달부터 시작됩니다.",
        B: "물론이죠, 양식을 제출하겠습니다.",
        C: "당신의 차는 주차장에 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 주차 허가증 갱신을 위한 양식을 제출하겠다는 응답입니다. A는 요청에 응하는 대신 새 정책에 대한 정보만 제공하는 부적절한 응답이고, C는 요청과 관련 없이 단순히 차량의 위치를 알려주는 부적절한 응답입니다.",
  },
  {
    questionNumber: 8,
    questionText: "Could you cite the reference in your report?",
    choices: {
      A: "The website is down at the conference site.",
      B: "Sure, I'll include it now.",
      C: "The reference desk is on the third floor.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "보고서에 참고 문헌을 인용해 주실 수 있나요?",
      choices: {
        A: "컨퍼런스 사이트의 웹사이트가 다운되었습니다.",
        B: "물론이죠, 지금 포함시키겠습니다.",
        C: "참고 자료 데스크는 3층에 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 참고 문헌을 보고서에 포함시키겠다는 응답입니다. A는 요청과 관련 없이 웹사이트 상태에 대한 정보를 제공하는 부적절한 응답이고, C는 'reference'를 '참고 자료 데스크'로 잘못 해석하여 위치 정보만 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 9,
    questionText: "Could you check the inventory levels this afternoon?",
    choices: {
      A: "Yes, I'll check with the Czech supplier.",
      B: "Certainly, I'll update the stock report.",
      C: "The inventory count is due next week.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "오늘 오후에 재고 수준을 확인해 주실 수 있나요?",
      choices: {
        A: "네, 체코 공급업체에 확인하겠습니다.",
        B: "물론이죠, 재고 보고서를 업데이트하겠습니다.",
        C: "재고 조사는 다음 주에 예정되어 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 재고 보고서를 업데이트하겠다는 응답입니다. A는 체코 공급업체에 확인하겠다는 내용으로 재고 수준 확인이라는 요청과 정확히 일치하지 않는 응답이고, C는 요청에 응하는 대신 단순히 재고 조사 일정에 대한 정보만 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 10,
    questionText: "Could you dial extension 303 for Mr. Lee?",
    choices: {
      A: "The diesel generator is nearby.",
      B: "The extension cord is broken.",
      C: "Sure, I'm dialing it now.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이씨를 위해 내선번호 303으로 전화해 주실 수 있나요?",
      choices: {
        A: "디젤 발전기가 근처에 있습니다.",
        B: "연장 코드가 고장났습니다.",
        C: "물론이죠, 지금 전화하고 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 내선번호로 전화를 걸고 있다는 응답입니다. A는 'dial'을 'diesel'로 잘못 해석하여 디젤 발전기에 대한 정보를 제공하는 부적절한 응답이고, B는 'extension'을 '연장 코드'로 잘못 해석하여 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 11,
    questionText: "Could you mail me the final invoice?",
    choices: {
      A: "The office closes at six.",
      B: "The mailroom is on the second floor.",
      C: "Of course, I'll mail it today.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "최종 청구서를 우편으로 보내주실 수 있나요?",
      choices: {
        A: "사무실은 6시에 닫습니다.",
        B: "우편실은 2층에 있습니다.",
        C: "물론이죠, 오늘 보내드리겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 청구서를 오늘 보내겠다는 응답입니다. A는 요청과 관련 없이 사무실 운영 시간에 대한 정보만 제공하는 부적절한 응답이고, B는 요청에 응하는 대신 단순히 우편실의 위치를 알려주는 부적절한 응답입니다.",
  },
  {
    questionNumber: 12,
    questionText: "Would you mind forwarding this email to HR?",
    choices: {
      A: "Certainly, I'll forward it now.",
      B: "The HR office moved to the third floor.",
      C: "I read the foreword before the introduction.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 이메일을 인사부에 전달해 주시겠어요?",
      choices: {
        A: "물론이죠, 지금 전달하겠습니다.",
        B: "인사부 사무실이 3층으로 이전했습니다.",
        C: "서문을 서론 전에 읽었습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 이메일을 전달하겠다는 응답입니다. B는 요청에 응하는 대신 단순히 인사부 사무실의 위치 정보를 제공하는 부적절한 응답이고, C는 'forward(전달하다)'와 발음이 비슷한 'foreword(서문)'을 혼동한 틀린 답변입니다.",
  },
  {
    questionNumber: 13,
    questionText: "Could you reserve a suite for the visiting executive?",
    choices: {
      A: "They serve sweet pastries in the café.",
      B: "Certainly, I'll book it now.",
      C: "The executive arrives at nine.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "방문하는 임원을 위해 스위트룸을 예약해 주실 수 있나요?",
      choices: {
        A: "카페에서 달콤한 페이스트리를 제공합니다.",
        B: "물론이죠, 지금 예약하겠습니다.",
        C: "임원은 9시에 도착합니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 스위트룸을 예약하겠다는 응답입니다. A는 'suite(스위트룸)'와 발음이 비슷한 'sweet(달콤한)'을 혼동한 틀린 답변이고, C는 요청에 응하는 대신 단순히 임원의 도착 시간에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 14,
    questionText: "Could you get me a copy of today's meeting minutes?",
    choices: {
      A: "Sure, I'll get a copy to you shortly.",
      B: "The minute hand on the clock is broken.",
      C: "The copy machine is in the next room.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "오늘 회의록 사본을 구해주실 수 있나요?",
      choices: {
        A: "물론이죠, 곧 사본을 가져다 드리겠습니다.",
        B: "시계의 분침이 고장났습니다.",
        C: "복사기는 옆방에 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 회의록 사본을 가져다 주겠다는 응답입니다. B는 'minutes(회의록)'와 발음이 비슷한 'minute(분)'을 혼동한 틀린 답변이고, C는 요청에 응하는 대신 단순히 복사기의 위치를 알려주는 부적절한 응답입니다.",
  },
  {
    questionNumber: 15,
    questionText: "Could you loan me some extra office supplies?",
    choices: {
      A: "The office is on the second floor.",
      B: "Sure, I'll loan them to you.",
      C: "I watched 'The Lone Ranger' last night.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "추가 사무용품을 빌려주실 수 있나요?",
      choices: {
        A: "사무실은 2층에 있습니다.",
        B: "물론이죠, 빌려드리겠습니다.",
        C: "어젯밤에 '론 레인저'를 봤습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 사무용품을 빌려주겠다는 응답입니다. A는 요청에 응하는 대신 단순히 사무실의 위치 정보를 제공하는 부적절한 응답이고, C는 'loan(빌려주다)'과 발음이 비슷한 'lone(외딴)'을 혼동한 틀린 답변입니다.",
  },
  {
    questionNumber: 16,
    questionText: "Would you mind checking our current stock levels?",
    choices: {
      A: "The registration fee is due next week.",
      B: "The inventory count is due next week.",
      C: "Certainly, I'll update the stock report.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "현재 재고 수준을 확인해 주시겠어요?",
      choices: {
        A: "등록비는 다음 주에 납부해야 합니다.",
        B: "재고 조사는 다음 주에 마감됩니다.",
        C: "물론이죠, 재고 보고서를 업데이트하겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 재고 보고서를 업데이트하겠다는 응답입니다. A는 'check(확인하다)'와 'check-in(체크인하다)'을 혼동한 부적절한 응답이고, B는 요청에 응하는 대신 단순히 재고 조사 마감일에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 17,
    questionText: "Could you write up the summary of today's discussion?",
    choices: {
      A: "Please get the right signatures before sending the document.",
      B: "Today's discussion was very productive.",
      C: "Sure, I'll write it up by 5 p.m.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "오늘 논의 내용을 요약해 주실 수 있나요?",
      choices: {
        A: "문서를 보내기 전에 올바른 서명을 받으세요.",
        B: "오늘 논의는 매우 생산적이었습니다.",
        C: "물론이죠, 오후 5시까지 작성해 드리겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 요약본을 작성해 주겠다는 응답입니다. A는 요청과 관련 없는 다른 지시를 하는 부적절한 응답이고, B는 요청에 응하는 대신 단순히 논의에 대한 평가를 제공하는 부적절한 응답입니다.",
  },

  {
    questionNumber: 18,
    questionText: "Could you ensure all participants receive the agenda?",
    choices: {
      A: "The agenda item on budgets comes first.",
      B: "The participants haven't arrived yet.",
      C: "No problem, I'll make sure everyone gets it.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "모든 참가자들이 의제를 받도록 확인해 주실 수 있나요?",
      choices: {
        A: "예산에 관한 의제 항목이 먼저 나옵니다.",
        B: "참가자들이 아직 도착하지 않았습니다.",
        C: "문제없습니다, 모두가 받을 수 있도록 하겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 모든 참가자가 의제를 받을 수 있도록 하겠다는 응답입니다. A는 요청에 응하는 대신 단순히 의제 항목의 순서에 대한 정보를 제공하는 부적절한 응답이고, B는 요청과 관련 없이 참가자들의 도착 상태만 알려주는 부적절한 응답입니다.",
  },
  {
    questionNumber: 19,
    questionText: "Could you send the updated report to all stakeholders?",
    choices: {
      A: "The steak is medium‑rare.",
      B: "I'll forward it to them right away.",
      C: "The beach is crowded with tourists.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "업데이트된 보고서를 모든 이해관계자들에게 보내주실 수 있나요?",
      choices: {
        A: "스테이크는 미디엄 레어입니다.",
        B: "즉시 그들에게 전달하겠습니다.",
        C: "해변은 관광객들로 붐비고 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 보고서를 이해관계자들에게 전달하겠다는 응답입니다. A는 요청과 전혀 관련 없는 스테이크에 대한 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 해변 상황에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 20,
    questionText: "Could you fill out this feedback form by Friday?",
    choices: {
      A: "I'll get it done by Friday.",
      B: "I read the discussion forum before posting.",
      C: "The office closes early on Fridays.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "금요일까지 이 피드백 양식을 작성해 주실 수 있나요?",
      choices: {
        A: "금요일까지 완료하겠습니다.",
        B: "게시하기 전에 토론 포럼을 읽었습니다.",
        C: "사무실은 금요일에 일찍 문을 닫습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 금요일까지 양식을 작성하겠다는 응답입니다. B는 요청과 관련 없는 토론 포럼에 대한 정보를 제공하는 부적절한 응답이고, C는 요청에 응하는 대신 단순히 사무실 운영 시간에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 21,
    questionText: "Could you cover my shift on Friday evening?",
    choices: {
      A: "I need to pick up my shirt from the dry cleaner.",
      B: "The break room is being cleaned.",
      C: "I'm afraid I won't be able to.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "금요일 저녁 제 근무 시간을 대신해 주실 수 있나요?",
      choices: {
        A: "세탁소에서 셔츠를 찾아와야 합니다.",
        B: "휴게실이 청소 중입니다.",
        C: "죄송하지만 제가 할 수 없을 것 같습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 근무 시간을 대신할 수 없다는 응답입니다. A는 요청과 직접적인 관련이 없는 셔츠를 찾아와야 한다는 정보를 제공하는 부적절한 응답이고, B는 요청과 전혀 관련 없는 휴게실 청소에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 22,
    questionText: "Would you mind forwarding the contract to our new client?",
    choices: {
      A: "Our contact at the firm is unreachable.",
      B: "I'm sorry, I have another deadline to meet.",
      C: "He'll visit the office next Tuesday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "새 고객에게 계약서를 전달해 주실 수 있을까요?",
      choices: {
        A: "회사의 담당자와 연락이 닿지 않습니다.",
        B: "죄송합니다만, 제가 맞춰야 할 다른 마감일이 있습니다.",
        C: "그는 다음 화요일에 사무실을 방문할 예정입니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 다른 마감일이 있어 요청을 수행할 수 없다는 응답입니다. A는 요청에 직접 응답하지 않고 회사 담당자와 연락이 닿지 않는다는 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 고객의 방문 일정에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 23,
    questionText: "Could you send me the revised agenda before the meeting?",
    choices: {
      A: "The parking area is behind the building.",
      B: "I'm sorry, I have another deadline that day.",
      C: "The agent from accounting is on leave.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "회의 전에 수정된 안건을 보내주실 수 있나요?",
      choices: {
        A: "주차장은 건물 뒤에 있습니다.",
        B: "죄송합니다만, 그날 제가 맞춰야 할 다른 마감일이 있습니다.",
        C: "회계 부서의 담당자가 휴가 중입니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 다른 마감일이 있어 요청을 수행할 수 없다는 응답입니다. A는 요청과 전혀 관련 없는 주차장 위치에 대한 정보를 제공하는 부적절한 응답이고, C는 요청에 응답하지 않고 회계 담당자의 휴가에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 24,
    questionText: "Could you compile a list of our top ten clients?",
    choices: {
      A: "I'm afraid I can't; I'm double‑booked this afternoon.",
      B: "The client network converged at noon yesterday.",
      C: "We need to comply with the new guidelines.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "우리의 상위 10개 고객 목록을 작성해 주실 수 있나요?",
      choices: {
        A: "죄송하지만 할 수 없습니다; 오늘 오후에 일정이 겹쳐 있습니다.",
        B: "고객 네트워크가 어제 정오에 통합되었습니다.",
        C: "우리는 새로운 지침을 준수해야 합니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 일정이 겹쳐 요청을 수행할 수 없다는 응답입니다. B는 요청과 관련 없는 고객 네트워크 통합에 대한 정보를 제공하는 부적절한 응답이고, C는 요청에 응답하지 않고 새로운 지침 준수에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 25,
    questionText: "Could you mail me the signed contract by Thursday?",
    choices: {
      A: "Mr. Kim from accounting is unavailable.",
      B: "I'm afraid I can't; I have another deadline.",
      C: "The male employees left the office early.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "목요일까지 서명된 계약서를 우편으로 보내주실 수 있나요?",
      choices: {
        A: "회계 부서의 김 씨는 부재중입니다.",
        B: "죄송하지만 할 수 없습니다; 다른 마감일이 있습니다.",
        C: "남자 직원들은 일찍 사무실을 떠났습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 다른 마감일이 있어 요청을 수행할 수 없다는 응답입니다. A는 요청에 직접 응답하지 않고 회계 부서 김 씨의 부재에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 남자 직원들의 퇴근에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 26,
    questionText: "Could you send me the latest sales data?",
    choices: {
      A: "I'm sorry, I can't; I'm out of the office today.",
      B: "The site is experiencing downtime.",
      C: "The project memo was distributed yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "최신 판매 데이터를 보내주실 수 있나요?",
      choices: {
        A: "죄송합니다만, 오늘은 사무실에 없어서 보내드릴 수 없습니다.",
        B: "사이트가 현재 다운타임을 겪고 있습니다.",
        C: "프로젝트 메모는 어제 배포되었습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 사무실에 없어 요청을 수행할 수 없다는 응답입니다. B는 요청에 직접 응답하지 않고 사이트 다운타임에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 프로젝트 메모 배포에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 27,
    questionText: "Would you mind booking the flight for our consultant?",
    choices: {
      A: "The hotel does not offer breakfast.",
      B: "Sorry, I can't; I'm handling another assignment.",
      C: "The lighting in the conference hall is outdated.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "우리 컨설턴트를 위한 항공편을 예약해 주시겠습니까?",
      choices: {
        A: "호텔에서는 아침 식사를 제공하지 않습니다.",
        B: "죄송합니다만, 다른 업무를 처리하고 있어서 할 수 없습니다.",
        C: "회의장의 조명이 오래되었습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 다른 업무를 처리하고 있어 요청을 수행할 수 없다는 응답입니다. A는 요청에 직접 응답하지 않고 호텔 아침 식사에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 회의장 조명에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 28,
    questionText: "Could you forward this email to the distribution list?",
    choices: {
      A: "The lease agreement is with legal.",
      B: "The printer queue is blocked.",
      C: "Sorry, I can't; I'm offsite this afternoon.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이 이메일을 배포 목록에 전달해 주실 수 있나요?",
      choices: {
        A: "임대 계약서는 법무팀에 있습니다.",
        B: "프린터 대기열이 막혔습니다.",
        C: "죄송합니다만, 오후에는 현장 외부에 있어서 할 수 없습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 오후에 현장 외부에 있어 요청을 수행할 수 없다는 응답입니다. A는 요청에 직접 응답하지 않고 임대 계약서에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, B는 요청과 관련 없는 프린터 대기열에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 29,
    questionText: "Would you please activate my new security badge?",
    choices: {
      A: "The parking permit expires tomorrow.",
      B: "The budget review meeting starts at 2 p.m.",
      C: "I'm afraid I can't; IT has locked the system.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "제 새 보안 배지를 활성화해 주시겠습니까?",
      choices: {
        A: "주차 허가증은 내일 만료됩니다.",
        B: "예산 검토 회의는 오후 2시에 시작합니다.",
        C: "죄송합니다만, IT 부서에서 시스템을 잠갔기 때문에 할 수 없습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 IT 부서에서 시스템을 잠갔기 때문에 요청을 수행할 수 없다는 응답입니다. A는 요청에 직접 응답하지 않고 주차 허가증에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, B는 요청과 관련 없는 예산 검토 회의에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 30,
    questionText:
      "Would you mind checking the presentation slideshow before the conference?",
    choices: {
      A: "The conference microphone is faulty.",
      B: "The show schedule was updated yesterday.",
      C: "Sorry, I can't; I'm preparing materials for another session.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "회의 전에 프레젠테이션 슬라이드쇼를 확인해 주시겠습니까?",
      choices: {
        A: "회의 마이크에 결함이 있습니다.",
        B: "쇼 일정이 어제 업데이트되었습니다.",
        C: "죄송합니다만, 다른 세션을 위한 자료를 준비하고 있어서 할 수 없습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 다른 세션을 위한 자료를 준비하고 있어 요청을 수행할 수 없다는 응답입니다. A는 요청에 직접 응답하지 않고 회의 마이크에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, B는 요청과 관련 없는 쇼 일정에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 31,
    questionText: "Could you arrange a conference call with our London branch?",
    choices: {
      A: "The conference center opens at nine.",
      B: "You don't need to; it's already been arranged.",
      C: "The call center is on the second floor.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "런던 지사와 전화 회의를 주선해 주실 수 있나요?",
      choices: {
        A: "회의 센터는 9시에 개장합니다.",
        B: "그럴 필요 없습니다; 이미 준비되어 있습니다.",
        C: "콜센터는 2층에 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 이미 전화 회의가 준비되어 있어 요청이 필요 없다는 응답입니다. A는 요청에 직접 응답하지 않고 회의 센터 개장 시간에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 콜센터 위치에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 32,
    questionText: "Could you send me the draft of the project proposal?",
    choices: {
      A: "The printer is out of ink.",
      B: "You don't have to; I already have it.",
      C: "The draft‑beer selection is extensive.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "프로젝트 제안서 초안을 보내주실 수 있나요?",
      choices: {
        A: "프린터에 잉크가 떨어졌습니다.",
        B: "그럴 필요 없습니다; 저는 이미 가지고 있습니다.",
        C: "생맥주 선택이 다양합니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 이미 제안서 초안을 가지고 있어 요청이 필요 없다는 응답입니다. A는 요청에 직접 응답하지 않고 프린터 잉크에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 생맥주 선택에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 33,
    questionText:
      "Would you mind updating the client database with the new information?",
    choices: {
      A: "The client lounge is closed today.",
      B: "It's not necessary; it's already been updated.",
      C: "The base station signal is weak.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "클라이언트 데이터베이스를 새 정보로 업데이트해 주시겠습니까?",
      choices: {
        A: "오늘은 클라이언트 라운지가 닫혀 있습니다.",
        B: "그럴 필요 없습니다; 이미 업데이트되었습니다.",
        C: "기지국 신호가 약합니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 이미 데이터베이스가 업데이트되어 있어 요청이 필요 없다는 응답입니다. A는 요청에 직접 응답하지 않고 클라이언트 라운지에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 기지국 신호에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 34,
    questionText: "Could you provide samples of the new product line?",
    choices: {
      A: "The sample catalog hasn't been printed yet.",
      B: "You can skip that; samples arrived yesterday.",
      C: "The produce department is under renovation.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "새 제품 라인의 샘플을 제공해 주실 수 있나요?",
      choices: {
        A: "샘플 카탈로그가 아직 인쇄되지 않았습니다.",
        B: "그것은 건너뛰어도 됩니다; 샘플이 어제 도착했습니다.",
        C: "농산물 부서가 현재 리모델링 중입니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 이미 샘플이 어제 도착했기 때문에 요청이 필요 없다는 응답입니다. A는 요청에 직접 응답하지 않고 샘플 카탈로그 인쇄에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 농산물 부서의 리모델링에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 35,
    questionText: "Could you confirm tomorrow's flight itinerary?",
    choices: {
      A: "No need; I have it in my email.",
      B: "The dietary guidelines were updated recently.",
      C: "The initiative to cut costs starts next month.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "내일의 비행 일정을 확인해 주실 수 있나요?",
      choices: {
        A: "필요 없습니다; 제 이메일에 있습니다.",
        B: "식이 지침이 최근에 업데이트되었습니다.",
        C: "비용 절감 이니셔티브는 다음 달에 시작됩니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 이미 비행 일정이 이메일에 있어 확인이 필요 없다는 응답입니다. B는 요청에 직접 응답하지 않고 식이 지침에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 비용 절감 이니셔티브에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 36,
    questionText: "Could you process my reimbursement request this afternoon?",
    choices: {
      A: "The recreation center is closed today.",
      B: "The processing unit is located in the server room.",
      C: "No need; Finance has taken care of it.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "오늘 오후에 제 환급 요청을 처리해 주실 수 있나요?",
      choices: {
        A: "오늘은 레크리에이션 센터가 닫혀 있습니다.",
        B: "처리 장치는 서버룸에 위치해 있습니다.",
        C: "필요 없습니다; 재무부서에서 이미 처리했습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 재무부서에서 이미 환급 요청을 처리했기 때문에 요청이 필요 없다는 응답입니다. A는 요청에 직접 응답하지 않고 레크리에이션 센터에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, B는 요청과 관련 없는 처리 장치의 위치에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 37,
    questionText: "Could you update the delivery schedule by noon?",
    choices: {
      A: "No need; it's already been updated.",
      B: "The software upgrade is scheduled for midnight.",
      C: "The downtown store closes at noon.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "정오까지 배송 일정을 업데이트해 주실 수 있나요?",
      choices: {
        A: "필요 없습니다; 이미 업데이트되었습니다.",
        B: "소프트웨어 업그레이드는 자정에 예정되어 있습니다.",
        C: "시내 매장은 정오에 닫습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 배송 일정이 이미 업데이트되었기 때문에 요청이 필요 없다는 응답입니다. B는 요청에 직접 응답하지 않고 소프트웨어 업그레이드에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 시내 매장의 영업 시간에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 38,
    questionText: "Could you organize a briefing for the new recruits?",
    choices: {
      A: "The recruitment fair is scheduled for next week.",
      B: "The briefcase was left in the lobby.",
      C: "That's unnecessary; HR conducted one yesterday.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "신입 사원들을 위한 브리핑을 준비해 주실 수 있나요?",
      choices: {
        A: "채용 박람회는 다음 주로 예정되어 있습니다.",
        B: "서류 가방이 로비에 놓여 있습니다.",
        C: "불필요합니다; 인사부서에서 어제 이미 진행했습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 인사부서에서 이미 어제 브리핑을 진행했기 때문에 요청이 불필요하다는 응답입니다. A는 요청에 직접 응답하지 않고 채용 박람회에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, B는 요청과 관련 없는 서류 가방의 위치에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 39,
    questionText: "Could you set up the projector before the presentation?",
    choices: {
      A: "No need; IT department has already installed it.",
      B: "The presenting author will speak first.",
      C: "The project deadline is tomorrow.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "발표 전에 프로젝터를 설치해 주실 수 있나요?",
      choices: {
        A: "필요 없습니다; IT 부서에서 이미 설치했습니다.",
        B: "발표자가 먼저 말씀하실 예정입니다.",
        C: "프로젝트 마감일은 내일입니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 IT 부서에서 이미 프로젝터를 설치했기 때문에 요청이 필요 없다는 응답입니다. B는 요청에 직접 응답하지 않고 발표자에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 프로젝트 마감일에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 40,
    questionText:
      "Would you mind ordering more office chairs for the training room?",
    choices: {
      A: "Office supplies are in storage.",
      B: "No need; the seating is already sufficient.",
      C: "The chairperson approved the budget yesterday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "교육실을 위한 사무용 의자를 더 주문해 주실 수 있나요?",
      choices: {
        A: "사무용품은 창고에 있습니다.",
        B: "필요 없습니다; 좌석은 이미 충분합니다.",
        C: "의장이 어제 예산을 승인했습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 좌석이 이미 충분하기 때문에 요청이 필요 없다는 응답입니다. A는 요청에 직접 응답하지 않고 사무용품의 위치에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 예산 승인에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 41,
    questionText: "Can the new brochure be sent to all participants?",
    choices: {
      A: "The brochure rack is in the lobby.",
      B: "Yes, I'll send it by 5 p.m.",
      C: "Participants can register online.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "새 브로셔를 모든 참가자에게 보낼 수 있나요?",
      choices: {
        A: "브로셔 진열대는 로비에 있습니다.",
        B: "네, 오후 5시까지 보내드리겠습니다.",
        C: "참가자들은 온라인으로 등록할 수 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 오후 5시까지 브로셔를 보내겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 브로셔 진열대의 위치에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 온라인 등록에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 42,
    questionText: "Could the updated report be uploaded to the server?",
    choices: {
      A: "The report template was printed yesterday.",
      B: "The upload speed is very slow.",
      C: "Certainly, I'll upload it now.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "업데이트된 보고서를 서버에 업로드할 수 있을까요?",
      choices: {
        A: "보고서 템플릿은 어제 인쇄되었습니다.",
        B: "업로드 속도가 매우 느립니다.",
        C: "물론이죠, 지금 업로드하겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 보고서를 지금 업로드하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 보고서 템플릿 인쇄에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, B는 요청에 직접 응답하지 않고 업로드 속도에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 43,
    questionText: "Can the training session be rescheduled for next Monday?",
    choices: {
      A: "Yes, we can move it to next Monday.",
      B: "The training materials were delivered.",
      C: "Monday morning coffee is served at 8.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "교육 세션을 다음 월요일로 일정을 변경할 수 있나요?",
      choices: {
        A: "네, 다음 월요일로 옮길 수 있습니다.",
        B: "교육 자료가 배달되었습니다.",
        C: "월요일 아침 커피는 8시에 제공됩니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 교육 세션을 다음 월요일로 옮길 수 있다는 긍정적인 응답입니다. B는 요청에 직접 응답하지 않고 교육 자료 배달에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 월요일 아침 커피 제공 시간에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 44,
    questionText: "Can you update the price list on the website?",
    choices: {
      A: "No need; we've already updated it.",
      B: "The webmaster's office is on the fourth floor.",
      C: "The prize‑winners list was announced yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "웹사이트의 가격 목록을 업데이트할 수 있나요?",
      choices: {
        A: "필요 없습니다; 이미 업데이트했습니다.",
        B: "웹마스터 사무실은 4층에 있습니다.",
        C: "수상자 목록은 어제 발표되었습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 이미 가격 목록을 업데이트했다는 응답입니다. B는 요청에 직접 응답하지 않고 웹마스터 사무실의 위치에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 전혀 관련 없는 수상자 목록 발표에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 45,
    questionText: "Can you lead the team meeting tomorrow?",
    choices: {
      A: "The team meeting agenda is on my desk.",
      B: "The pipes were made of lead.",
      C: "No, I won't be able to lead it.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "내일 팀 회의를 이끌어 줄 수 있나요?",
      choices: {
        A: "팀 회의 안건이 제 책상에 있습니다.",
        B: "파이프는 납으로 만들어졌습니다.",
        C: "아니요, 제가 이끌 수 없을 것 같습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 내일 팀 회의를 이끌 수 없다는 부정적인 응답입니다. A는 요청에 직접 응답하지 않고 팀 회의 안건의 위치에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, B는 요청과 전혀 관련 없는 파이프의 재질에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 46,
    questionText: "Could you forward the report to the board members?",
    choices: {
      A: "The board meeting starts at three.",
      B: "Yes, I'll forward it right away.",
      C: "Everyone seemed bored during the presentation.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이사회 구성원들에게 보고서를 전달해 주실 수 있나요?",
      choices: {
        A: "이사회 회의는 3시에 시작합니다.",
        B: "네, 바로 전달하겠습니다.",
        C: "발표 중에 모두가 지루해 보였습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 보고서를 바로 전달하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 이사회 회의 시작 시간에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 발표 중 참석자들의 반응에 대한 정보를 제공하는 부적절한 응답입니다.",
  },

  {
    questionNumber: 47,
    questionText: "Could you pass my compliments to the customer support team?",
    choices: {
      A: "The customer support line is automated.",
      B: "The team's complement has increased this quarter.",
      C: "Certainly, I'll pass them on.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "고객 지원팀에게 제 칭찬을 전달해 주실 수 있나요?",
      choices: {
        A: "고객 지원 라인은 자동화되어 있습니다.",
        B: "팀의 인원이 이번 분기에 증가했습니다.",
        C: "물론이죠, 전달해 드리겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 칭찬을 전달하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 고객 지원 라인이 자동화되어 있다는 관련 없는 정보를 제공하는 부적절한 응답이고, B는 요청과 관련 없는 팀 인원 증가에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 48,
    questionText: "Could you process the expense report by Friday?",
    choices: {
      A: "The accounting department is on the third floor.",
      B: "No need; it's already been processed.",
      C: "The balance due is listed in the summary.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "금요일까지 경비 보고서를 처리해 주실 수 있나요?",
      choices: {
        A: "회계부서는 3층에 있습니다.",
        B: "필요 없습니다; 이미 처리되었습니다.",
        C: "미지급 잔액은 요약본에 기재되어 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 이미 경비 보고서가 처리되었기 때문에 필요 없다는 응답입니다. A는 요청에 직접 응답하지 않고 회계부서의 위치에 대한 관련 없는 정보를 제공하는 부적절한 응답이고, C는 요청과 관련 없는 미지급 잔액에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 49,
    questionText: "Could you counsel the new interns on company policy?",
    choices: {
      A: "The council meeting is scheduled for tomorrow.",
      B: "No need; HR already handles that.",
      C: "The internet connection is slow.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "새로운 인턴들에게 회사 정책에 대해 조언해 주실 수 있나요?",
      choices: {
        A: "위원회 회의는 내일로 예정되어 있습니다.",
        B: "필요 없습니다; HR에서 이미 그것을 처리합니다.",
        C: "인터넷 연결이 느립니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 HR에서 이미 인턴들에게 회사 정책에 대한 조언을 처리하고 있기 때문에 불필요함을 표명하는 정답입니다. A는 'counsel(조언하다)'과 'council(위원회)'의 발음 유사성을 이용한 함정으로, 요청에 직접 응답하지 않고 위원회 회의 일정에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'interns(인턴들)'과 'internet(인터넷)'의 철자 유사성을 이용한 함정으로, 요청과 전혀 관련 없는 인터넷 연결 속도에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 50,
    questionText: "Could you advise the team on the new software update?",
    choices: {
      A: "No need; they've already been advised.",
      B: "The advisory board meets monthly.",
      C: "The update requires a reboot.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question:
        "팀에게 새로운 소프트웨어 업데이트에 대해 조언해 주실 수 있나요?",
      choices: {
        A: "필요 없습니다; 그들은 이미 조언을 받았습니다.",
        B: "자문 위원회는 매월 모입니다.",
        C: "업데이트는 재부팅이 필요합니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 팀이 이미 조언을 받았기 때문에 필요 없다는 응답입니다. B는 'advise(조언하다)'와 'advisory(자문의)'의 단어 유사성을 이용한 함정으로, 요청에 직접 응답하지 않고 자문 위원회 모임에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 요청과 관련 없는 업데이트의 기술적 요구사항에 대한 정보만 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 51,
    questionText: "Could you deposit the cheque before closing time?",
    choices: {
      A: "The deadline is approaching quickly.",
      B: "Certainly, I'll deposit it today.",
      C: "They issue receipts with each check.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "마감 시간 전에 수표를 입금해 주실 수 있나요?",
      choices: {
        A: "마감일이 빠르게 다가오고 있습니다.",
        B: "물론이죠, 오늘 입금하겠습니다.",
        C: "그들은 각 수표마다 영수증을 발행합니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 수표를 오늘 입금하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 마감일에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 요청과 관련 없는 영수증 발행에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 52,
    questionText: "Could you compliment the chef on tonight's dinner?",
    choices: {
      A: "The dinner plate is in the cabinet.",
      B: "The menu selection changes weekly.",
      C: "Certainly, I'll compliment him.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "오늘 저녁 식사에 대해 요리사에게 칭찬해 주실 수 있나요?",
      choices: {
        A: "저녁 식사 접시는 캐비닛에 있습니다.",
        B: "메뉴 선택은 매주 변경됩니다.",
        C: "물론이죠, 그에게 칭찬하겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 요리사에게 칭찬하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 저녁 식사 접시의 위치에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. B는 요청과 관련 없는 메뉴 변경에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 53,
    questionText: "Could you forward my call to extension 201?",
    choices: {
      A: "The excursion bus leaves at nine.",
      B: "No problem, I'll forward it now.",
      C: "The extension cord is broken.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "내 전화를 201번 내선으로 연결해 주실 수 있나요?",
      choices: {
        A: "관광 버스는 9시에 출발합니다.",
        B: "문제없습니다, 지금 연결해 드리겠습니다.",
        C: "연장 코드가 고장났습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 전화를 지금 연결해 주겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 관광 버스 출발 시간에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'extension(내선)'과 'extension cord(연장 코드)'의 단어 유사성을 이용한 함정으로, 요청과 관련 없는 연장 코드의 상태에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 54,
    questionText: "Could you check in for my flight online?",
    choices: {
      A: "Absolutely, I'll check in now.",
      B: "The checkout counter is busy.",
      C: "My annual checkup is next Wednesday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "내 항공편을 온라인으로 체크인해 주실 수 있나요?",
      choices: {
        A: "물론이죠, 지금 체크인하겠습니다.",
        B: "체크아웃 카운터가 혼잡합니다.",
        C: "내 연례 건강검진은 다음 수요일입니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 지금 체크인해 주겠다는 긍정적인 응답입니다. B는 요청에 직접 응답하지 않고 'check in'과 'checkout'의 단어 유사성을 이용한 함정으로, 체크아웃 카운터에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'check in'과 'checkup'의 단어 유사성을 이용한 함정으로, 건강검진에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 55,
    questionText: "Could you fill out this survey by tomorrow?",
    choices: {
      A: "Of course, I'll fill it out tonight.",
      B: "The survey results will be published later.",
      C: "The conveyor belt is in the factory.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 설문조사를 내일까지 작성해 주실 수 있나요?",
      choices: {
        A: "물론이죠, 오늘 밤에 작성하겠습니다.",
        B: "설문조사 결과는 나중에 발표될 예정입니다.",
        C: "컨베이어 벨트는 공장에 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 오늘 밤에 설문조사를 작성하겠다는 긍정적인 응답입니다. B는 요청에 직접 응답하지 않고 설문조사 결과에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 요청과 전혀 관련 없는 컨베이어 벨트의 위치에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 56,
    questionText: "Could you unlock the office door when you arrive?",
    choices: {
      A: "No problem, I'll unlock it then.",
      B: "The lockup procedure is automated.",
      C: "The odor in the hallway is noticeable.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "도착하시면 사무실 문을 열어주실 수 있나요?",
      choices: {
        A: "문제없어요, 그때 열어드리겠습니다.",
        B: "잠금 절차는 자동화되어 있습니다.",
        C: "복도의 냄새가 눈에 띕니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 도착 시 문을 열어주겠다는 긍정적인 응답입니다. B는 요청에 직접 응답하지 않고 'unlock'과 'lockup'의 단어 유사성을 이용한 함정으로, 잠금 절차에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'door'와 'odor'의 발음 유사성을 이용한 함정으로, 복도의 냄새에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 57,
    questionText: "Could you arrange a shuttle from the airport to the hotel?",
    choices: {
      A: "Certainly, I'll arrange it now.",
      B: "The shuttle schedule is posted online.",
      C: "The window shutters are closed.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "공항에서 호텔까지 셔틀을 준비해 주실 수 있나요?",
      choices: {
        A: "물론이죠, 지금 준비하겠습니다.",
        B: "셔틀 일정은 온라인에 게시되어 있습니다.",
        C: "창문 셔터가 닫혀 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 셔틀을 준비해 주겠다는 긍정적인 응답입니다. B는 요청에 직접 응답하지 않고 셔틀 일정에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'shuttle'과 'shutter'의 단어 유사성을 이용한 함정으로, 창문 셔터에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 58,
    questionText: "Could you print 20 copies of this report by noon?",
    choices: {
      A: "Sure, I'll print them right away.",
      B: "The printer ink is running low.",
      C: "No one has the key.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "정오까지 이 보고서를 20부 인쇄해 주실 수 있나요?",
      choices: {
        A: "물론이죠, 바로 인쇄하겠습니다.",
        B: "프린터 잉크가 부족합니다.",
        C: "아무도 열쇠를 가지고 있지 않습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 보고서를 바로 인쇄하겠다는 긍정적인 응답입니다. B는 요청에 직접 응답하지 않고 프린터 잉크 상태에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 요청과 전혀 관련 없는 열쇠에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 59,
    questionText: "Could you reserve a conference room for next Monday?",
    choices: {
      A: "The entrance door is locked.",
      B: "Sure, I'll reserve it now.",
      C: "Restoration work starts next week.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "다음 월요일에 회의실을 예약해 주실 수 있나요?",
      choices: {
        A: "입구 문이 잠겨 있습니다.",
        B: "물론이죠, 지금 예약하겠습니다.",
        C: "복원 작업이 다음 주에 시작됩니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 회의실을 예약해 주겠다는 긍정적인 응답입니다. A는 요청과 전혀 관련 없는 입구 문에 대한 정보를 제공하는 부적절한 응답입니다. C는 'reserve'와 'restoration'의 단어 유사성을 이용한 함정으로, 복원 작업에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 60,
    questionText: "Could you ensure the backup completes before midnight?",
    choices: {
      A: "The backup schedule is in the server room.",
      B: "They insure shipments automatically.",
      C: "Certainly, I'll ensure it finishes by then.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "백업이 자정 전에 완료되도록 확인해 주실 수 있나요?",
      choices: {
        A: "백업 일정은 서버실에 있습니다.",
        B: "그들은 배송물을 자동으로 보험 처리합니다.",
        C: "물론이죠, 그때까지 완료되도록 확인하겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 백업이 자정 전에 완료되도록 확인하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 백업 일정에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. B는 'ensure'와 'insure'의 단어 유사성을 이용한 함정으로, 보험 처리에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 61,
    questionText:
      "Please inform the maintenance team that the printer is out of order.",
    choices: {
      A: "The maintenance schedule is on the noticeboard.",
      B: "The main tenant moved out last week.",
      C: "Certainly, I'll inform them right away.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "프린터가 고장났다고 유지보수팀에 알려주세요.",
      choices: {
        A: "유지보수 일정은 게시판에 있습니다.",
        B: "주요 세입자가 지난주에 이사했습니다.",
        C: "물론이죠, 바로 알리겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 유지보수팀에 바로 알리겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 유지보수 일정에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. B는 'maintenance'와 'main tenant'의 발음 유사성을 이용한 함정으로, 세입자에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 62,
    questionText: "Please notify HR that I will be late tomorrow.",
    choices: {
      A: "Sure, I'll notify them immediately.",
      B: "The HR handbook is available online.",
      C: "I will bring my personal ID.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "내일 늦을 것이라고 인사부에 알려주세요.",
      choices: {
        A: "물론이죠, 즉시 알리겠습니다.",
        B: "인사부 핸드북은 온라인에서 이용 가능합니다.",
        C: "제 개인 신분증을 가져오겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 인사부에 즉시 알리겠다는 긍정적인 응답입니다. B는 요청에 직접 응답하지 않고 인사부 핸드북에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 요청과 전혀 관련 없는 개인 신분증에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 63,
    questionText: "Please tell the vendor to deliver the materials by 3 p.m.",
    choices: {
      A: "The material costs are increasing.",
      B: "I'll tell them to deliver it on time.",
      C: "The maternity‑leave policy was updated last week.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "공급업체에 자재를 오후 3시까지 배달하라고 전해주세요.",
      choices: {
        A: "자재 비용이 증가하고 있습니다.",
        B: "제때 배달하라고 전하겠습니다.",
        C: "출산휴가 정책이 지난주에 업데이트되었습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 공급업체에 제때 배달하라고 전하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 자재 비용에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'materials'와 'maternity'의 발음 유사성을 이용한 함정으로, 출산휴가 정책에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 64,
    questionText: "Please verify the guest list for tomorrow's dinner.",
    choices: {
      A: "The variety of dishes is impressive.",
      B: "Certainly, I'll verify the list now.",
      C: "The guest speaker list has been finalized.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "내일 저녁 식사를 위한 손님 명단을 확인해 주세요.",
      choices: {
        A: "요리의 다양성이 인상적입니다.",
        B: "물론이죠, 지금 명단을 확인하겠습니다.",
        C: "초청 연사 목록이 확정되었습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 손님 명단을 확인하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 요리의 다양성에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'guest list'와 'guest speaker list'의 단어 유사성을 이용한 함정으로, 초청 연사 목록에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 65,
    questionText:
      "Please confirm with the finance department that the budget report is accurate.",
    choices: {
      A: "The finance portal is down.",
      B: "Of course, I'll confirm it with finance.",
      C: "Budget cuts start next month.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "재무부서에 예산 보고서가 정확한지 확인해 주세요.",
      choices: {
        A: "재무 포털이 다운되었습니다.",
        B: "물론이죠, 재무부서에 확인하겠습니다.",
        C: "예산 삭감이 다음 달에 시작됩니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 재무부서에 확인하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 재무 포털 상태에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 요청과 관련 없는 예산 삭감에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 66,
    questionText: "Please forward the email to the marketing department.",
    choices: {
      A: "The marketing budget was approved today.",
      B: "I read the foreword in the report.",
      C: "Sure, I'll forward it to marketing.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "마케팅 부서에 이메일을 전달해 주세요.",
      choices: {
        A: "마케팅 예산이 오늘 승인되었습니다.",
        B: "보고서의 서문을 읽었습니다.",
        C: "물론이죠, 마케팅 부서에 전달하겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 마케팅 부서에 이메일을 전달하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 마케팅 예산에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. B는 'forward'와 'foreword'의 발음 유사성을 이용한 함정으로, 보고서 서문에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 67,
    questionText:
      "Please advise the design team on the project specifications.",
    choices: {
      A: "The design manual is in the archive.",
      B: "The advisory board meets tomorrow.",
      C: "Certainly, I'll advise them accordingly.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "디자인 팀에게 프로젝트 사양에 대해 조언해 주세요.",
      choices: {
        A: "디자인 매뉴얼은 아카이브에 있습니다.",
        B: "자문 위원회는 내일 모입니다.",
        C: "물론이죠, 그에 따라 조언하겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 디자인 팀에게 조언하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 디자인 매뉴얼 위치에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. B는 'advise'와 'advisory'의 단어 유사성을 이용한 함정으로, 자문 위원회 모임에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 68,
    questionText:
      "Please update the legal department on the contract revisions.",
    choices: {
      A: "The legal guidelines were updated last month.",
      B: "Sure, I'll update them now.",
      C: "The contact list was updated yesterday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "법무부서에 계약 수정사항에 대해 업데이트해 주세요.",
      choices: {
        A: "법적 지침은 지난달에 업데이트되었습니다.",
        B: "물론이죠, 지금 업데이트하겠습니다.",
        C: "연락처 목록은 어제 업데이트되었습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 지금 업데이트하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 법적 지침 업데이트에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'contract'와 'contact'의 발음 유사성을 이용한 함정으로, 연락처 목록에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 69,
    questionText: "Please arrange courier pickup for the sample package.",
    choices: {
      A: "The courier counter is near the exit.",
      B: "Sorry, I can't; I have another task.",
      C: "The temple service starts at noon.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "샘플 패키지를 위한 택배 픽업을 준비해 주세요.",
      choices: {
        A: "택배 카운터는 출구 근처에 있습니다.",
        B: "죄송합니다, 할 수 없어요; 다른 업무가 있습니다.",
        C: "사원 예배는 정오에 시작합니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 다른 업무가 있어 요청을 수행할 수 없다는 부정적이지만 적절한 응답입니다. A는 요청에 직접 응답하지 않고 택배 카운터 위치에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'courier'와 'temple'의 발음 유사성을 이용한 함정으로, 사원 예배에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 70,
    questionText: "Please schedule a follow‑up meeting with the client.",
    choices: {
      A: "The meeting room is already booked.",
      B: "The complaint was filed yesterday.",
      C: "Certainly, I'll schedule the follow‑up.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "고객과 후속 회의를 일정에 잡아 주세요.",
      choices: {
        A: "회의실은 이미 예약되어 있습니다.",
        B: "불만 사항은 어제 접수되었습니다.",
        C: "물론이죠, 후속 회의를 일정에 넣겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 후속 회의를 일정에 넣겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 회의실 예약 상태에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. B는 'follow-up'과 'complaint'의 개념적 연관성을 이용한 함정으로, 불만 사항 접수에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 71,
    questionText:
      "Please send me the signed inspection report by this afternoon.",
    choices: {
      A: "The inspection schedule was posted yesterday.",
      B: "Certainly, I'll send it by this afternoon.",
      C: "She built a strong rapport with the client.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "오늘 오후까지 서명된 검사 보고서를 보내주세요.",
      choices: {
        A: "검사 일정은 어제 게시되었습니다.",
        B: "물론이죠, 오후까지 보내드리겠습니다.",
        C: "그녀는 고객과 강한 유대 관계를 구축했습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 오후까지 보고서를 보내겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 검사 일정에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'report'와 'rapport'의 발음 유사성을 이용한 함정으로, 고객과의 유대 관계에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 72,
    questionText: "Please arrange a guided tour of the museum.",
    choices: {
      A: "Sure, I'll arrange the tour tomorrow.",
      B: "The museum opening hours changed.",
      C: "The musical event starts at 3 p.m.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "박물관 가이드 투어를 준비해 주세요.",
      choices: {
        A: "네, 내일 투어를 준비하겠습니다.",
        B: "박물관 개관 시간이 변경되었습니다.",
        C: "음악 행사는 오후 3시에 시작합니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 투어를 준비하겠다는 긍정적인 응답입니다. B는 요청에 직접 응답하지 않고 박물관 개관 시간에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'museum'과 'musical'의 단어 유사성을 이용한 함정으로, 음악 행사에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 73,
    questionText: "Please cite all sources in your report.",
    choices: {
      A: "The site map is available online.",
      B: "The report template is outdated.",
      C: "Sure, I'll cite all sources properly.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "보고서에 모든 출처를 인용해 주세요.",
      choices: {
        A: "사이트 맵은 온라인에서 이용 가능합니다.",
        B: "보고서 템플릿이 오래되었습니다.",
        C: "네, 모든 출처를 적절히 인용하겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 모든 출처를 적절히 인용하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 사이트 맵에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. B는 요청과 관련이 있지만 출처 인용에 대한 요청에 직접 응답하지 않고 보고서 템플릿에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 74,
    questionText: "Please reserve parking spaces for our VIP guests.",
    choices: {
      A: "The parking garage closes at 8 p.m.",
      B: "The spare tires are in the garage.",
      C: "No need; they've already been reserved.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "VIP 손님들을 위한 주차 공간을 예약해 주세요.",
      choices: {
        A: "주차장은 오후 8시에 닫습니다.",
        B: "예비 타이어는 차고에 있습니다.",
        C: "필요 없습니다; 이미 예약되어 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 주차 공간이 이미 예약되어 있다는 응답입니다. A는 요청에 직접 응답하지 않고 주차장 폐장 시간에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. B는 'parking spaces'와 'spare tires'의 관련성을 이용한 함정으로, 예비 타이어에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 75,
    questionText: "Please show the tutorial video to the new hires.",
    choices: {
      A: "The tutor schedule is updated weekly.",
      B: "Higher‑level documentation is available online.",
      C: "I'm afraid I won't be able to; I'm in a meeting.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "신입 직원들에게 튜토리얼 비디오를 보여주세요.",
      choices: {
        A: "튜터 일정은 매주 업데이트됩니다.",
        B: "상위 수준의 문서는 온라인에서 이용 가능합니다.",
        C: "죄송합니다만 할 수 없을 것 같습니다; 회의 중입니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 회의 중이라 비디오를 보여줄 수 없다는 응답입니다. A는 요청에 직접 응답하지 않고 'tutorial'과 'tutor'의 단어 유사성을 이용한 함정으로, 튜터 일정에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. B는 요청과 관련이 있지만 튜토리얼 비디오를 보여달라는 요청에 직접 응답하지 않고 문서에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 76,
    questionText:
      "Please read the attached contract and send me your feedback.",
    choices: {
      A: "I'll review it and send feedback soon.",
      B: "The contract has been archived.",
      C: "The contact list has been updated.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "첨부된 계약서를 읽고 피드백을 보내주세요.",
      choices: {
        A: "검토 후 곧 피드백을 보내드리겠습니다.",
        B: "계약서가 보관되었습니다.",
        C: "연락처 목록이 업데이트되었습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 계약서를 검토하고 피드백을 보내겠다는 긍정적인 응답입니다. B는 요청에 직접 응답하지 않고 계약서가 보관되었다는 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'contract'와 'contact'의 단어 유사성을 이용한 함정으로, 연락처 목록에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 77,
    questionText: "Please expedite the processing of these applications.",
    choices: {
      A: "The application deadline is next Monday.",
      B: "They installed an expediter in the lobby.",
      C: "I'll expedite them today.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이 신청서들의 처리를 신속히 진행해 주세요.",
      choices: {
        A: "신청 마감일은 다음 월요일입니다.",
        B: "로비에 신속처리기를 설치했습니다.",
        C: "오늘 신속히 처리하겠습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. C는 질문에 대한 직접적인 대답으로 신청서를 오늘 신속히 처리하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 신청 마감일에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. B는 'expedite(신속히 처리하다)'와 'expediter(신속처리기)'의 단어 유사성을 이용한 함정으로, 로비의 장비에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 78,
    questionText: "Please confirm my keynote speaker's travel arrangements.",
    choices: {
      A: "The speaker system is on mute.",
      B: "I will make sure the travel is confirmed.",
      C: "The key notch on the board is broken.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "기조 연설자의 여행 일정을 확인해 주세요.",
      choices: {
        A: "스피커 시스템이 음소거되어 있습니다.",
        B: "여행 일정을 확인해 드리겠습니다.",
        C: "보드의 키 홈이 고장났습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 여행 일정을 확인하겠다는 긍정적인 응답입니다. A는 'speaker'라는 단어의 중의성을 이용한 함정으로, 연설자가 아닌 스피커 시스템에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'keynote'와 'key notch'의 단어 유사성을 이용한 함정으로, 보드의 키 홈에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 79,
    questionText: "Please check the inventory levels before closing.",
    choices: {
      A: "The inventory report is available online.",
      B: "Alright, I'll check them before closing.",
      C: "The in‑service training begins tomorrow.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "마감 전에 재고 수준을 확인해 주세요.",
      choices: {
        A: "재고 보고서는 온라인에서 확인 가능합니다.",
        B: "알겠습니다, 마감 전에 확인하겠습니다.",
        C: "직원 교육은 내일 시작됩니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 마감 전에 재고를 확인하겠다는 긍정적인 응답입니다. A는 요청에 직접 응답하지 않고 재고 보고서의 위치에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 요청과 전혀 관련이 없는 직원 교육에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 80,
    questionText: "Please finalize the monthly newsletter by Thursday.",
    choices: {
      A: "The membership list is printed weekly.",
      B: "I'll finish it by Thursday.",
      C: "The net profit report is due next Monday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "목요일까지 월간 뉴스레터를 완성해 주세요.",
      choices: {
        A: "회원 목록은 매주 인쇄됩니다.",
        B: "목요일까지 완성하겠습니다.",
        C: "순이익 보고서는 다음 월요일까지 제출해야 합니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 목요일까지 뉴스레터를 완성하겠다는 긍정적인 응답입니다. A는 요청과 관련 없는 회원 목록에 대한 정보를 제공하는 부적절한 응답입니다. C는 요청과 관련 없는 순이익 보고서에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 81,
    questionText: "May I have your permission to leave early today?",
    choices: {
      A: "The permission slip is on your desk.",
      B: "Of course, you may leave at 4 p.m.",
      C: "The permit office is next door.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "오늘 일찍 퇴근해도 될까요?",
      choices: {
        A: "허가서는 당신의 책상 위에 있습니다.",
        B: "물론이죠, 오후 4시에 퇴근하셔도 됩니다.",
        C: "허가 사무실은 옆 방에 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 일찍 퇴근해도 된다는 허가를 명확히 해주는 적절한 응답입니다. A는 'permission'이라는 단어를 사용했지만 실제 허가 요청에 응답하지 않고 허가서의 위치에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다. C는 'permit'이라는 단어를 사용했지만 허가 사무실의 위치에 대한 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 82,
    questionText: "May I take a day off next Friday?",
    choices: {
      A: "I'm afraid you may not; we need all staff.",
      B: "The break room closes at 5 p.m.",
      C: "The bake sale is on that day.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "다음 금요일에 휴가를 써도 될까요?",
      choices: {
        A: "죄송하지만 안 됩니다; 모든 직원이 필요합니다.",
        B: "휴게실은 오후 5시에 닫습니다.",
        C: "그날은 베이크 세일이 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'에 관한 질문입니다. A는 질문에 대한 직접적인 대답으로, 비록 부정적이지만 휴가 요청에 명확하게 응답하고 그 이유(모든 직원이 필요함)를 제시하는 적절한 응답입니다. B는 휴게실 폐쇄 시간에 대한 정보를 제공하는데, 이는 휴가 요청과 전혀 관련이 없는 부적절한 응답입니다. C는 베이크 세일 행사에 대한 정보를 제공하는데, 이 역시 휴가 요청에 대한 직접적인 응답이 아니라 관련 없는 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 83,
    questionText: "May I request three additional copies of the report?",
    choices: {
      A: "The copy room is at the end of the hall.",
      B: "Sure, I'll print three more.",
      C: "The coupon expires tomorrow.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "보고서 추가 사본 세 부를 요청해도 될까요?",
      choices: {
        A: "복사실은 복도 끝에 있습니다.",
        B: "물론이죠, 세 부 더 인쇄해 드리겠습니다.",
        C: "쿠폰은 내일 만료됩니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 보고서 추가 사본을 인쇄해 주겠다는 긍정적인 응답입니다. A는 요청과 관련 없는 복사실의 위치에 대한 정보를 제공하는 부적절한 응답입니다. C는 요청과 완전히 관련 없는 쿠폰 만료에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 84,
    questionText: "May I join the webinar hosted by HR?",
    choices: {
      A: "Sure, I'll register you.",
      B: "The hardware upgrade is pending.",
      C: "The barber closed early today.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "인사부에서 주최하는 웨비나에 참여해도 될까요?",
      choices: {
        A: "물론이죠, 등록해 드리겠습니다.",
        B: "하드웨어 업그레이드가 보류 중입니다.",
        C: "이발소가 오늘 일찍 문을 닫았습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 웨비나에 등록해 주겠다는 긍정적인 응답입니다. B는 요청과 관련 없는 하드웨어 업그레이드에 대한 정보를 제공하는 부적절한 응답입니다. C는 요청과 완전히 관련 없는 이발소에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 85,
    questionText: "May I please speak to Ms. Jenkins in Human Resources?",
    choices: {
      A: "Of course, I'll transfer your call.",
      B: "The human resources manual was updated last week.",
      C: "The humidity levels are high today.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "인사부의 젠킨스 씨와 통화할 수 있을까요?",
      choices: {
        A: "물론이죠, 전화를 연결해 드리겠습니다.",
        B: "인사부 매뉴얼이 지난주에 업데이트되었습니다.",
        C: "오늘은 습도가 높습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 젠킨스 씨에게 전화를 연결해 주겠다는 긍정적인 응답입니다. B는 요청과 관련 없는 인사부 매뉴얼에 대한 정보를 제공하는 부적절한 응답입니다. C는 요청과 완전히 관련 없는 날씨 상태에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 86,
    questionText: "May I please talk to the on‑duty manager?",
    choices: {
      A: "The duty roster was sent this morning.",
      B: "I'm sorry—no manager is available now.",
      C: "The dessert menu is on the table.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "당직 매니저와 통화할 수 있을까요?",
      choices: {
        A: "당직 명단이 오늘 아침에 발송되었습니다.",
        B: "죄송합니다만, 현재 이용 가능한 매니저가 없습니다.",
        C: "디저트 메뉴가 테이블 위에 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 현재 매니저가 없다는 정보를 제공하는 적절한 응답입니다. A는 요청과 관련 없는 당직 명단에 대한 정보를 제공하는 부적절한 응답입니다. C는 요청과 완전히 관련 없는 디저트 메뉴에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 87,
    questionText: "May I review the safety instructions before starting work?",
    choices: {
      A: "Absolutely … they're posted on the wall.",
      B: "The safety gloves are in the locker.",
      C: "The satisfactions survey is due.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "작업을 시작하기 전에 안전 지침을 검토해도 될까요?",
      choices: {
        A: "물론이죠. 벽에 게시되어 있습니다.",
        B: "안전 장갑은 사물함에 있습니다.",
        C: "만족도 설문조사 제출 기한이 다가왔습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 안전 지침이 어디에 있는지 알려주는 적절한 응답입니다. B는 요청과 직접적으로 관련이 없는 안전 장갑의 위치에 대한 정보를 제공하는 부적절한 응답입니다. C는 요청과 완전히 관련 없는 만족도 설문조사에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 88,
    questionText: "May I adjust the volume on the conference microphone?",
    choices: {
      A: "Absolutely, you may adjust it.",
      B: "The microphone manual is on the portal.",
      C: "The concert hall is booked.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의용 마이크 볼륨을 조절해도 될까요?",
      choices: {
        A: "물론이죠, 조절하셔도 됩니다.",
        B: "마이크 설명서는 포털에 있습니다.",
        C: "콘서트홀은 예약되어 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 마이크 볼륨을 조절해도 된다는 허락을 주는 적절한 응답입니다. B는 요청과 직접적으로 관련이 없는 마이크 설명서의 위치에 대한 정보를 제공하는 부적절한 응답입니다. C는 요청과 완전히 관련 없는 콘서트홀 예약에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 89,
    questionText: "May I borrow a stapler from your desk?",
    choices: {
      A: "The stapler is in the supply closet.",
      B: "Sure, you may borrow it.",
      C: "The staples are in the drawer.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "당신의 책상에서 스테이플러를 빌려도 될까요?",
      choices: {
        A: "스테이플러는 비품 보관함에 있습니다.",
        B: "물론이죠, 빌려가셔도 됩니다.",
        C: "스테이플 심은 서랍에 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. B는 질문에 대한 직접적인 대답으로 스테이플러를 빌려가도 된다는 허락을 주는 적절한 응답입니다. A는 스테이플러의 위치에 대한 정보를 제공하지만 요청에 대한 직접적인 허락이 아닌 부적절한 응답입니다. C는 요청과 직접적으로 관련이 없는 스테이플 심의 위치에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
  {
    questionNumber: 90,
    questionText: "May I have a glass of water from the cooler?",
    choices: {
      A: "Absolutely, you may have one.",
      B: "The water filter needs cleaning.",
      C: "The heater is overheating.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "정수기에서 물 한 잔 마셔도 될까요?",
      choices: {
        A: "물론이죠, 드셔도 됩니다.",
        B: "정수 필터를 청소해야 합니다.",
        C: "히터가 과열되고 있습니다.",
      },
    },
    explanation:
      "이 문제는 '요청'을 묻는 질문입니다. A는 질문에 대한 직접적인 대답으로 물을 마셔도 된다는 허락을 주는 적절한 응답입니다. B는 요청과 직접적으로 관련이 없는 정수 필터 청소에 대한 정보를 제공하는 부적절한 응답입니다. C는 요청과 완전히 관련 없는 히터 과열에 대한 정보를 제공하는 부적절한 응답입니다.",
  },
];
